import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import {
  billingGetPlans,
  billingCreatePlan,
  billingDeletePlan,
  billingUpdatePlan,
} from "@/store/billing";

import { Plan } from '@/types'

import AppButton from "@/components/AppButton";
import AppText from "@/components/AppText";
import AppModal from "@/components/AppModal";
import AppBox from "@/components/AppBox";
import AppLoader from "@/components/AppLoader";
import CreatePlanModal from "@/components/Modals/CreatePlanModal";
import PlansTable from "@/components/Tables/PlansTable";



const Plans: React.FC = () => {
  const dispatch = useAppDispatch();
  const { plans, status } = useAppSelector((state) => state.billing);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentPlan, setCurrentPlan] = useState<Partial<Plan>>({});

  // Fetch plans on component mount
  useEffect(() => {
    dispatch(billingGetPlans());
  }, [dispatch]);

  // Open and close modal handlers
  const handleOpenCreatePlanModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  // Plan actions
  const handleCreatePlan = async (data: Plan) => {
    await dispatch(billingCreatePlan(data));
    handleCloseModal();
  };

  const handleEditPlan = (row: Plan) => {
    setCurrentPlan(row);
    handleOpenCreatePlanModal();
  };

  const handleDeletePlan = async (row: Plan) => {
    await dispatch(billingDeletePlan(row.id));
  };

  const handleChangeDefaultPlan = async (data: Plan) => {
    await dispatch(billingUpdatePlan({ id: data.id,  data: { ...data, current: true } }));
  };

  return (
    <AppBox fullWidth fullHeight column gap={4}>
      {/* Header Section */}
      <AppBox justify="between" align="center" fullWidth>
        <AppText variant="h2">
          Plans
        </AppText>

        <AppBox width={220}>
          <AppButton onClick={handleOpenCreatePlanModal}>
            Create Plan
          </AppButton>
        </AppBox>
      </AppBox>

      {/* Content Section */}
      {status === "loading" ? (
        <AppBox center>
          <AppLoader />
        </AppBox>
      ) : (
        <PlansTable
          tableRows={plans}
          onEdit={handleEditPlan}
          onDelete={handleDeletePlan}
          onChangeDefaultPlan={handleChangeDefaultPlan}
        />
      )}

      {/* Create Plan Modal */}
      <AppModal isOpen={isOpen} title="Create Plan" onClose={handleCloseModal}>
        <CreatePlanModal onSubmit={handleCreatePlan} currentPlan={currentPlan} />
      </AppModal>
    </AppBox>
  );
};

export default Plans;